<template>
  <div>
    <!-- <search v-if="dataStatructureReady" @submit="(data) => filterHandler(data)" /> -->

    <vs-table
      multiple
      class="vs-con-loading__container loader_optionTable"
      @search="handleSearch"
      @sort="handleSort"
      max-items="3"
      v-model="selected"
      :data="tableComputedData"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse centerx p-3 items-end">
          <!-- ADD NEW -->
          <div
            class="p-4 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="insertData()"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">{{ mainSettings.tableSettings.addBtnLabel }}</span>
          </div>
        </div>
        <!-- ITEMS PER PAGE -->
        <vs-dropdown
          vs-trigger-click
          class="cursor-pointer mb-4 mr-4"
          v-if="mainSettings.tableSettings.showItemPerPageOption"
        >
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span
              class="mr-2"
            >{{ currentPage * per_page - (per_page - 1) }} - {{ pageTotal - currentPage * per_page > 0 ? currentPage * per_page : pageTotal }} of {{ totalData }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="per_page=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="per_page=20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="per_page=30">
              <span>30</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="per_page=50">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="per_page=100">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <template v-for="(fName,indexTd) in dataStructure">
          <vs-th
            v-if="fName.showInTable == 'yes'"
            :sort-key="indexTd"
            :key="indexTd"
          >{{fName.label }}</vs-th>
        </template>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <template v-for="(fName,indexTd) in dataStructure">
            <template v-if="fName.showInTable == 'yes'">
              <vs-td
                v-if="fName.type == 'aronSelect'"
                :data="data[indextr][indexTd]"
                :key="indexTd"
              >{{decodeSelectValue(indextr,indexTd,fName.data)}}</vs-td>

              <vs-td
                v-else-if="fName.type == 'aronMultiSelect'"
                :data="data[indextr][indexTd]"
                :key="indexTd"
              >{{decodeMultiSelectValue(indextr,indexTd)}}</vs-td>

              <vs-td
                v-else
                :data="data[indextr][indexTd]"
                :key="indexTd"
              >{{ data[indextr][indexTd] }}</vs-td>
            </template>
          </template>
        </vs-tr>
      </template>
    </vs-table>

    <div>
      <vs-pagination :total="pageTotal" v-model="currentx" goto></vs-pagination>
    </div>
    <div class="flex flex-wrap-reverse centerx p-3 items-end">
      <!-- ADD NEW -->
      <div
        class="p-4 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
        @click="insertData()"
      >
        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-primary">{{ mainSettings.tableSettings.addBtnLabel }}</span>
      </div>
    </div>
  </div>
</template>
  
<script>
import axios from "@/axios.js";

//form type
import { alertMixin } from "../../mixin/alertMixin";
import { axiosMixin } from "../../mixin/axiosMixin";
import { helperMixin } from "../../mixin/helperMixin";
import { mapGetters } from "vuex";

// import search from "./search";
import OptiontableSettings from "./tableSetting.js";

export default {
  components: {
    // search
  },
  mixins: [alertMixin, axiosMixin, helperMixin],
  data: () => ({
    tableSettings: OptiontableSettings,
    operation: "add",
    dataStructure: {},
    tblData: [],
    selected: [],
    log: [],
    currentx: 1,
    pageTotal: 1,
    per_page: 10,
    sort_by: "id",
    sort_direction: "desc",
    totalData: 0,
    isMounted: false,
    //for sidebar form
    addNewDataSidebar: false,
    sidebarData: {},
    dataStatructureReady: false,
    filterData: {}
  }),
  props: {
    settingsKey: {
      type: String
    }
  },
  watch: {
    currentx: function() {
      this.getData("from current x");
    },
    per_page: function() {
      this.getData("from perpage");
    }
  },
  computed: {
    ...mapGetters({
      getProfileId: "profile/getProfileId",
      getMainInfo: "profile/getMainInfo"
    }),
    baseURl() {
      return axios.defaults.baseURL;
    },
    currentPage() {
      if (this.isMounted) {
        return this.currentx;
      }
      return 0;
    },
    tableComputedData() {
      return this.tblData;
    },
    mainSettings() {
      var filteredSettings = this.tableSettings.filter(
        f => f.key == this.settingsKey
      );
      console.log("thesettings:", filteredSettings[0]);
      return filteredSettings[0];
    }
  },
  methods: {
    idCompser(id) {
      return "btnDelete" + id;
    },
    filterHandler(data) {
      this.filterData = data;
      this.addToObject(this.mainSettings.filter, {
        advanceFilter: this.filterData
      });

      this.getData();
    },

    returnFilters() {
      return {
        pkId: this.getMainInfo.prVendorId
      };
    },
    startLoading(id) {
      try {
        this.$vs.loading({
          container: "." + id,
          scale: 0.6
        });
      } catch (error) {}
    },
    stopLoading(id) {
      try {
        this.$vs.loading.close("." + id + " > .con-vs-loading");
      } catch (error) {}
    },

    decodeSelectValue(tr, td, options) {
      return this.decodeValueForSelect(options, this.tblData[tr][td]);
    },
    // decodeSelectValue(value,options) {
    //  return this.arrayOfObjectFind(options,value)[0].label;
    // },
    decodeMultiSelectValue(tr, td) {
      return this.flattenJsonStringArray(this.tblData[tr][td], "label");
    },
    addNew($val) {
      if (this.sort_direction == "asc") {
        var newTotalPage = Math.ceil((this.totalData + 1) / this.per_page);
        if (this.currentx != newTotalPage) {
          this.currentx = newTotalPage;
        } else {
          this.getData("add new");
        }
      } else {
        if (this.currentx == this.pageTotal) {
          this.getData("add new");
        } else {
          this.currentx = this.pageTotal;
        }
      }
    },
    handleSearch(searching) {
      console.log("search:", searching);
    },

    handleSort(key, direction) {
      this.sort_by = key;
      this.sort_direction = direction;
      this.getData("from sort");
    },

    insertDone(val) {
      this.getData("insert");
    },
    getData(from) {
      console.log("test here");
      this.startLoading("loader_optionTable");
      var params = "page=" + this.currentx + "&per_page=" + this.per_page;
      var sort =
        "&sort_by=" + this.sort_by + "&sort_direction=" + this.sort_direction;

      console.log("filter:", this.mainSettings.tableSettings.filter);
      console.log(
        "filter:",
        this.countObject(this.mainSettings.tableSettings.filter)
      );
      if (this.countObject(this.mainSettings.tableSettings.filter) > 0) {
        console.log("here");
        this.aronPost(
          this.mainSettings.tableSettings.filterEndpoint,
          this.mainSettings.tableSettings.filter,
          params,
          sort
        )
          .then(response => {
            if (response.status == 200) {
              this.tblData = response.data.data;
              this.dataStructure = response.data.fields;

              this.dataStatructureReady = true;
              this.totalData = response.data.meta.pagination.total;
              this.pageTotal = response.data.meta.pagination.total_pages;
              console.log("this.dataStructure:", this.dataStructure);
            }

            this.stopLoading("loader_optionTable");
          })
          .catch(error => {
            // this.decodeErrorFromAxios(error);
            this.stopLoading("loader_optionTable");
          });
      } else {
        console.log(" or here");
        this.aronGet(this.mainSettings.tableSettings.route, params, sort)
          .then(response => {
            this.tblData = response.data.data;
            this.dataStructure = response.data.fields;

            this.dataStatructureReady = true;

            this.pageTotal = response.data.meta.pagination.total_pages;
            this.totalData = response.data.meta.pagination.total;

            console.log("this.dataStructure:", this.dataStructure);
            this.stopLoading("loader_optionTable");
          })
          .catch(error => {
            this.stopLoading("loader_optionTable");
            //this.decodeErrorFromAxios(error);
          });
      }
    },
    insertData() {
      console.log("selected:", this.selected); //this.addToObject(this.selected,this.filterEndpoint)
      this.aronPost(
        this.mainSettings.tableSettings.postEndpoint,
        { items: this.selected, id: this.getProfileId },
        "",
        ""
      )
        .then(response => { 
          this.$store.state.profile.showPopup = false;
          this.$emit("input", "to Refresh data");
        })
        .catch(error => { 
          this.closeLoading();
        });
    }
  },

  created() {
    this.dataStatructureReady = false;
    this.isMounted = false;
  },
  mounted() {
    this.isMounted = true;
    console.log("mainSettingsssssssssss:", this.mainSettings);
    this.getData("created");
  }
};
</script>
<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
          &.img-container {
            // width: 1rem;
            // background: #fff;

            span {
              display: flex;
              justify-content: flex-start;
            }

            .product-img {
              height: 110px;
            }
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style